import { ASSIGNED_SPACE_POST_DETAILS_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { SpacePost } from 'core/models/Space';

const initialState: { spacePost: SpacePost | null, isLoading: boolean } = {
  spacePost: null,
  isLoading: false
}

interface ActionType extends Action {
  payload: {
    spacePost: SpacePost;
  }
}

export default function spacePostDetailsReducer(state = initialState, action: ActionType) {

  switch (action.type) {
    case ASSIGNED_SPACE_POST_DETAILS_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case ASSIGNED_SPACE_POST_DETAILS_ACTION.SUCCESS:
      const { spacePost } = action.payload;
      return { ...state, spacePost, isLoading: false }

    case ASSIGNED_SPACE_POST_DETAILS_ACTION.FAILURE:
      return { ...state, ...initialState }

    default:
      return state
  }
}